import { api } from '../../../config';

export const RESPOND_LIST_PAGE_SIZE = 500;

export const buildRespondTypeResponseListUrl = ({
  procurementId,
  procurementMitraId = null,
  pageSize = RESPOND_LIST_PAGE_SIZE,
} = {}) => {
  const params = new URLSearchParams();
  if (procurementId) params.set('ProcurementId', String(procurementId));
  if (procurementMitraId) {
    params.set('ProcurementMitraId', String(procurementMitraId));
  }
  params.set('PageSize', String(pageSize));
  return `${api.API_URL}/respond-operational-tolerance-validity-document?${params.toString()}`;
};

export const buildRespondClauseListUrl = ({
  procurementId,
  procurementMitraId = null,
  pageSize = RESPOND_LIST_PAGE_SIZE,
} = {}) => {
  const params = new URLSearchParams();
  if (procurementId) params.set('ProcurementId', String(procurementId));
  if (procurementMitraId) {
    params.set('ProcurementMitraId', String(procurementMitraId));
  }
  params.set('PageSize', String(pageSize));
  return `${api.API_URL}/respond-clause-detail?${params.toString()}`;
};
